// src/components/Modals/ConfirmDialog.js
import React from "react";
import styles from "../../pages/Styles.module.css"; // Ajuste o caminho do CSS se necessário
import stylesModal from "./Modal.module.css"; // Seu CSS de modal

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, busy, isDestructive }) => {
  if (!open) return null;
  
  return (
    <div className={stylesModal.modalOverlay} style={{ zIndex: 10000 }}>
      <div className={stylesModal.modal} style={{ maxWidth: 400, padding: 20, height: 'auto' }}>
        <h2 className={stylesModal.modalTitle} style={{ color: isDestructive ? '#e74c3c' : '#333', marginBottom: 10 }}>
            {title}
        </h2>
        <p style={{ margin: '15px 0', color: '#555', lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
           <button className={styles.btnSecondary} onClick={onCancel} disabled={busy}>Cancelar</button>
           <button 
                className={isDestructive ? styles.encerrarVotacao : styles.iniciarVotacao} 
                onClick={onConfirm} 
                disabled={busy}
            >
                {busy ? "Processando..." : "Confirmar"}
            </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;